<template>
  <section>
    <b-field>
      <b-autocomplete
        style="border-radius:4px; border: 1px solid #ccc"
        v-model="name"
        placeholder="Find learner in school"
        :keep-first="true"
        :open-on-focus="true"
        :data="filteredDataObj"
        field="firstName"
        expanded
        icon="magnify"
        :clearable="true"
        @select="option => searchedUser(option)"
        clear-on-select
      >
        <template slot-scope="props">
          <div class="media">
            <div class="media-content">
              {{
                `${props.option.firstName} ${
                  props.option.lastName === "n/a" ? "" : props.option.lastName
                }, ${localeGrade(props.option.grade)}`
              }}
            </div>
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";

export default {
  name: "Searchbar",
  props: {
    label: String,
    studentsList: {
      type: Array
    }
  },
  mixins: [localizationMixin],
  data() {
    return {
      name: "",
      selected: null
    };
  },
  computed: {
    filteredDataObj() {
      if (!this.studentsList) {
        return [];
      }
      return this.studentsList.filter(option => {
        return (
          option.firstName?.toString().toLowerCase().indexOf(this.name.toLowerCase()) >= 0 ||
          option.lastName?.toString().toLowerCase().indexOf(this.name.toLowerCase()) >= 0 ||
          `${option.firstName?.toString()} ${option.lastName?.toString()}`.toLowerCase().indexOf(this.name.toLowerCase()) >= 0
        );
      });
    }
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsLearnerModalActive",
      updateActiveUser: "globalStore/updateActiveUser"
    }),
    searchedUser(user) {
      this.$nextTick(() => {
        if (user) {
          this.updateActiveUser(user);
          this.isModalActive(true);
        }
      });
    },
    localeGrade(grade) {
      return this.contextualSpecificGradeAndLabel(grade);
    }
  }
};
</script>
